<template>
  <div>
    <div class="side-box__row d-flex align-items-center mt-3" :class="{ 'justify-content-end': !showLabel }">
      <span v-if="showLabel" class="side-box__content__label" />
      <div v-if="showCreate" class="w-100 side-box__content__input ml-3">
        <div class="text-right ml-3">
          <a @click="$emit('openBox', 'newTransform')">
            {{ $t("vytvoritNovouTransormacniFunkci") }}
          </a>
        </div>
      </div>
    </div>

    <div class="side-box__row d-flex align-items-center">
      <span v-if="showLabel" class="side-box__content__label">
        {{ $t("transformacniFunkce") }}
      </span>
      <div
        v-if="showField"
        :class="{ 'ml-3': showLabel }"
        class="side-box__content__input custom-control__select"
        :style="{ maxWidth: showLabel ? undefined : '100%' }"
      >
        <div
          class="custom-control__select__selected d-flex"
          :class="{ opened: transformsOpened }"
          @click="transformsOpened = !transformsOpened"
        >
          <div class="d-flex flex-wrap w-100">
            <span v-if="selectedTransform === {}" class="gray-text">
              {{ $t("vyberteTransformacniFunkci") }}
            </span>
            <div v-else class="d-flex align-items-center justify-content-between w-100">
              <span class="font-weight-light">
                {{ selectedTransform.label || $t("noTransformFunction") }}
                <br />
                <span class="text-smallest">
                  {{ getSubtypeDisplay(selectedTransform.subType) }}
                </span>
              </span>
              <div
                v-if="selectedTransform.transformationId"
                class="atom-icon"
                @click="handleOpenTransformEdit(selectedTransform, $event)"
              >
                <img
                  v-if="selectedTransform.public"
                  src="@/assets/icons/actions/icon_preview_border.svg"
                  alt=""
                  width="20"
                />
                <img v-else src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg" alt="" width="20" />
              </div>
            </div>
          </div>
        </div>
        <div class="custom-control__select__options" :class="{ opened: transformsOpened }">
          <div
            v-for="transform of loadedTransformsWithEmptyOption"
            :key="`transformOptionDiv${transform.transformationId}`"
            class="custom-control__select__option d-flex align-items-center"
            @click="handleTransformSelected(transform)"
          >
            <div
              class="d-flex justify-content-between w-100"
              :style="{
                fontStyle: !transform.transformationId ? 'italic' : 'normal'
              }"
            >
              <span class="font-weight-light">
                {{ transform.label || $t("noTransformFunction") }}
                <br />
                <span class="text-smallest">
                  {{ getSubtypeDisplay(selectedTransform.subType) }}
                </span>
              </span>
              <div
                v-if="transform.transformationId"
                class="atom-icon"
                @click="handleOpenTransformEdit(transform, $event)"
              >
                <img v-if="transform.public" src="@/assets/icons/actions/icon_preview_border.svg" alt="" width="20" />
                <img v-else src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg" alt="" width="20" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="side-box" :class="{ active: openedBoxes.indexOf('newTransform') >= 0 }">
        <span v-show="openedBoxes.indexOf('newTransform') >= 0" class="side-box__overlay" />
        <div
          class="side-box__inner"
          :class="{
            opened: openedBoxes.indexOf('newTransform') >= 0,
            'last-active': openedBoxes.indexOf('newTransform') === openedBoxes.length - 1
          }"
          style="z-index: 1"
        >
          <div class="side-box__header d-flex justify-content-between align-items-center">
            <div class="atom-back atom-back--gray" @click="$emit('closeBox', 'newTransform')">
              <div class="atom-back__inner d-flex align-items-center">
                <img src="@/assets/icons/arrows/arr-gray-left.svg" />
                <span>{{ $t("zpet") }}</span>
              </div>
            </div>
            <button class="btn btn-primary" @click="handleCreateTransform()">
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
              </div>
              {{ $t("vytvoritTransformacniFunkci") }}
            </button>
          </div>
          <div class="side-box__title">
            <h2>{{ $t("novaTransformacniFunkce") }}</h2>
          </div>
          <div class="side-box__content">
            <div v-if="errors.transform" class="text-danger">
              {{ errors.transform }}
            </div>
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label">
                {{ $t("nazevTransformacniFunkce") }}
              </span>
              <div
                class="side-box__content__input custom-control__custom-input ml-3"
                :class="{
                  'has-error': errors.transform && !newTransform.label
                }"
              >
                <span v-if="!newTransform.label" class="placeholder">
                  {{ $t("zadejteNazevTransformacniFunkce") }}
                </span>
                <input
                  v-model="newTransform.label"
                  autofocus
                  class="w-100"
                  maxlength="30"
                  minlength="1"
                  placeholder=""
                  type="text"
                />
              </div>
            </div>
            <div class="side-box__row d-flex align-items-center mt-3">
              <span class="side-box__content__label">
                {{ $t("transformacniFunkce") }}
              </span>
              <div
                class="side-box__content__input custom-control__custom-input ml-3"
                :class="{
                  'has-error': errors.transform && !newTransform.definition
                }"
              >
                <textarea
                  v-model="newTransform.definition"
                  class="p-2 w-100"
                  :placeholder="$t('zadejteTransformacniFunkci')"
                  autofocus
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="side-box" :class="{ active: openedBoxes.indexOf('editTransform') >= 0 }">
        <span v-show="openedBoxes.indexOf('editTransform') >= 0" class="side-box__overlay" />
        <div
          class="side-box__inner"
          :class="{
            opened: openedBoxes.indexOf('editTransform') >= 0,
            'last-active': openedBoxes.indexOf('editTransform') === openedBoxes.length - 1
          }"
          style="z-index: 1"
        >
          <EditTransformationModal
            :error="errors.transform"
            :transform="editedTransform"
            @change="editedTransform[$event.field] = $event.value"
            @close="$emit('closeBox', 'editTransform')"
            @copied="handleTransformCopied"
            @deleted="handleTransformDeleted"
            @error="handleTransformSaveError"
            @saved="handleTransformSaved"
          />
        </div>
      </div>
    </div>
    <SaveConfirmationModal
      :opened="openedTransformConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @yes="handleCreateTransform"
      @no="
        () => {
          clearTransform()
          $emit('closeBox', 'newTransform')
        }
      "
      @close="toggleTransformConfirmation"
    />
    <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="isErrorOpen" @close="isErrorOpen = false" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import { useTransformationFunctionsStore } from "@/store/modules/transformationFunctions"

import SaveConfirmationModal from "@/components/confirmations/save.vue"
import EditTransformationModal from "@/components/modals/transformations/edit.vue"
import ErrorModal from "@/components/confirmations/error.vue"
import { useProjectStore } from "@/store/modules/project"

export default {
  name: "TransformFunctionField",
  components: { ErrorModal, EditTransformationModal, SaveConfirmationModal },
  emits: ["change", "closeBox", "editedTransform", "loaded", "openBox"],
  props: {
    initialTransformId: {
      type: Number,
      required: false
    },
    openedBoxes: {
      type: Array,
      required: true
    },
    showCreate: {
      type: Boolean,
      required: false,
      default: true
    },
    showLabel: {
      type: Boolean,
      required: false,
      default: true
    },
    subType: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    transformationList: {
      type: Array,
      required: false,
      default: () => []
    },
    showField: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  setup() {
    const projectStore = useProjectStore()
    const tfStore = useTransformationFunctionsStore()

    return { projectStore, tfStore }
  },
  data: () => ({
    editedTransform: {},
    errors: {},
    errorsToTranslate: [],
    isErrorOpen: false,
    loadedTransforms: [],
    openedTransformConfirmation: false,
    openedTransformEdit: false,
    newTransform: {},
    selectedTransform: {},
    transformsOpened: false
  }),
  computed: {
    transformationFunction() {
      return this.tfStore.detail
    },
    transformationFunctionList() {
      return this.tfStore.list
    },
    project() {
      return this.projectStore.selectedProject
    },
    loadedTransformsWithEmptyOption() {
      if (this.transformationList.length) {
        return [{ ...this.emptyTransform }, ...this.transformationList]
      } else {
        return [{ ...this.emptyTransform }, ...this.loadedTransforms]
      }
    },
    emptyTransform() {
      return {
        label: "",
        public: 0,
        transformationId: null,
        type: this.type,
        subType: this.subType,
        projectId: this.$route.params.projectId
      }
    }
  },
  watch: {
    initialTransformId: {
      async handler(newId, oldId) {
        if (!this.initialTransformId || newId === oldId) {
          return
        }

        await this.loadTransforms()

        this.selectedTransform = this.loadedTransforms.find((t) => t.transformationId === this.initialTransformId) || {
          ...this.emptyTransform
        }

        this.$emit("change", this.selectedTransform)
      },
      immediate: true
    },
    project: {
      async handler(project, oldProject) {
        if (!project?.projectId || project.projectId === oldProject?.projectId) {
          return
        }

        await this.loadTransforms()

        this.selectedTransform = this.loadedTransforms.find((t) => t.transformationId === this.initialTransformId) || {
          ...this.emptyTransform
        }

        this.newTransform = { ...this.emptyTransform }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations({
      setError: "modals/setError"
    }),
    setTransformationFunction(data) {
      this.tfStore.setDetail(data)
    },
    createTransformationFunction() {
      return this.tfStore.create()
    },
    getTransformationFunction(id) {
      return this.tfStore.getDetail(id)
    },
    getTransformationFunctionList() {
      return this.tfStore.getList()
    },
    clearTransform() {
      this.newTransform = {
        label: "",
        definition: "",
        public: 0,
        type: this.type,
        subType: this.subType
      }
      this.errors.transform = ""
    },
    async loadTransforms() {
      try {
        const params = {
          "type[eq]": this.type,
          "subType[eq]": this.subType,
          "sort[eq]": "public"
        }
        await this.getTransformationFunctionList(params)
        this.loadedTransforms = this.transformationFunctionList.filter(t => t.public || t.projectId === this.$route.params.projectId)
        this.$emit("loaded", this.loadedTransforms)
      } catch (e) {
        this.handleTransformSaveError(e.data?.errors.messages || { data: "Server error" })
      }
    },
    async handleCreateTransform() {
      this.errorsToTranslate = []

      if (!this.newTransform.label || !this.newTransform.definition) {
        this.errors.transform = this.$t("fillAllFieldsError")
        return
      }

      try {
        this.setTransformationFunction(this.newTransform)
        const newId = await this.createTransformationFunction()

        await this.getTransformationFunction(newId)
        this.selectedTransform = this.transformationFunction

        this.$emit("change", this.selectedTransform)
        this.$emit("closeBox", "newTransform")
      } catch (error) {
        // TODO dořešit propagaci errorů
        this.errorsToTranslate.push(error.data)
        this.openedError1 = true
      }
    },
    handleOpenTransformEdit(transform, event) {
      event.stopPropagation()
      this.editedTransform = { ...transform }
      this.$emit("editedTransform", { ...transform })
      this.$emit("openBox", "editTransform")
    },
    handleTransformCopied(newTransform) {
      this.editedTransform = newTransform
      this.loadTransforms()
    },
    handleTransformDeleted() {
      if (this.selectedTransform.transformationId === this.editedTransform.transformationId) {
        this.selectedTransform = { ...this.emptyTransform }
        this.$emit("change", {})
      }

      this.editedTransform = {}
      this.loadTransforms()
    },
    handleTransformSaved() {
      if (this.selectedTransform.transformationId === this.editedTransform.transformationId) {
        this.selectedTransform = { ...this.editedTransform }
        this.editedTransform = { ...this.emptyTransform }
      }

      this.loadTransforms()
      this.$emit("closeBox", "editTransform")
      this.$emit("updated")
    },
    handleTransformSaveError(error) {
      this.setError(error.data)
    },
    handleTransformSelected(transform) {
      this.selectedTransform = transform
      this.$emit("change", transform)
      this.transformsOpened = false
    },
    toggleTransformConfirmation() {
      this.openedTransformConfirmation = !this.openedTransformConfirmation
    },
    getSubtypeDisplay(subType) {
      if (subType === "LORA") {
        return this.$t("lora")
      }

      return this.$t(subType ?? "")
    }
  }
}
</script>
